import React from 'react';
import { Typography } from 'kangarootime-ui';

const Header = ({ label, sublabel, ...props }) => {
  return (
    <div style={{ backgroundColor: '#E8E9EC', padding: '8px 12px' }}>
      <Typography type='header' style={{ textAlign: 'center', lineHeight: 'normal', fontSize: '0.75rem', fontWeight: 600 }}>{label}</Typography>
      <Typography type='header' style={{ textAlign: 'center', lineHeight: 'normal', fontSize: '0.625rem' }}>{sublabel}</Typography>
    </div>
  );
};

export default Header;
